const moment = require('moment');

function ogDateFilter($translate) {
  return function(date, pattern) {
    return moment(date).locale($translate.use()).format(pattern);
  };
}

ogDateFilter.$inject = ['$translate'];

module.exports = ogDateFilter;
